<template>
  <div class="container">
    <div class="intro-top flex flex_content_sb">
      <div class="left">
        <template v-if="langSet == 'cn'">
          <div>
            中国国际医药原料药/中间体/包装/设备交易会（API
            China）深耕中国医药市场40余年，现已成为医药工业全球品牌开拓中国市场的重要平台。API
            China展会以服务药品全链条创新为核心使命，覆盖药品从研发至生产全流程各个环节过程中产品与技术，网罗全球制药企业与供应链资源，展会同期举办内容丰富的会议论坛与行业活动，时刻把脉政策风向，驱动制药行业创新之力。实现线上线下双轨服务，365天精准配对，拓客全球、链接无限商机。
          </div>
          <div>
            即刻加入API China，一站解锁产品展示、技术交流、商贸合作等无限可能！
          </div>
        </template>
        <template v-else>
          <div>
            API China has been deeply engaged in China’s pharmaceutical market
            for over 40 years. It has now become an essential platform for
            global pharmaceutical brands seeking to enter and expand within the
            Chinese market. Its core mission is to support innovation across the
            entire pharmaceutical supply chain. Covering products and
            technologies throughout the entire drug development process. From
            research and development to production, API China brings together
            global pharmaceutical companies and supply chain resources.
            Alongside the exhibition, a rich program of conferences, forums, and
            industry events is held to interpret policy trends and drive
            innovation within the pharmaceutical sector. API China offers online
            and offline services, providing year-round precise matching,
            expanding global customer base and connecting with unlimited
            business opportunities.
          </div>
          <div>
            Join API China now to unlock endless possibilities in product
            showcasing, technological exchange, and business cooperation, all in
            one place!
          </div>
        </template>
      </div>
      <div class="right">
<!--        src="https://oss.file.apichina.com.cn/apichina/var/upload/video/dac951ea72b28ac80d4f8f1e355c7877.mp4"-->
<!--        换地址 2026.5.22 dxm 秀鸽-->
        <video
          v-if="langSet == 'cn'"
          id="video"
          src="https://oss.file.apichina.com.cn/apichina/var/upload/video/1f8a647b004ae6ff6bb144f6288c5b50.mp4"
          controls
          webkit-playsinline
          playsInline
          x5-playsinline
          t7-video-player-type="inline"
          controlsList="nodownload noremoteplayback disablePictureInPicture noplaybackrate"
        ></video>
        <video
          v-if="langSet == 'en'"
          id="video"
          src="https://oss.file.apichina.com.cn/apichina/var/upload/video/1f8a647b004ae6ff6bb144f6288c5b50.mp4"
          controls
          webkit-playsinline
          playsInline
          x5-playsinline
          t7-video-player-type="inline"
          controlsList="nodownload noremoteplayback disablePictureInPicture noplaybackrate"
        ></video>
      </div>
    </div>
    <div class="intro-list flex flex_wrap" ref="scroll">
      <div class="item flex" v-for="(item, index) in list" :key="index">
        <el-image class="icon" :src="item.icon"></el-image>
        <div class="item-con">
          <div class="num">
            <count-to
              v-if="showNum"
              :start-val="0"
              :end-val="item.num"
              :duration="2000"
            ></count-to
            >{{ item.unit }}
          </div>
          <div>{{ langSet == "cn" ? item.title : item.title_en }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import countTo from "vue-count-to";
export default {
  components: {
    countTo,
  },
  props: {
    introduceData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      langSet: "",
      list: [
        {
          icon: require("../../../assets/intro_icon1.png"),
          num: 0,
          title: "展览面积",
          title_en: "Exhibition Area",
          unit: "m²",
        },
        {
          icon: require("../../../assets/intro_icon2.png"),
          num: 0,
          title: "参展企业",
          title_en: "Exhibitors",
          unit: "+",
        },
        {
          icon: require("../../../assets/intro_icon3.png"),
          num: 0,
          title: "专业观众",
          title_en: "Professional Visitors",
          unit: "+",
        },
        {
          icon: require("../../../assets/intro_icon4.png"),
          num: 0,
          title: "前沿会议",
          title_en: "Cutting-Edge Conferences",
          unit: "+",
        },
        {
          icon: require("../../../assets/intro_icon5.png"),
          num: 0,
          title: "一对一采购对接会",
          title_en: "One-on-One Procurement Matchmaking Meetings",
          unit: "+",
        },
        {
          icon: require("../../../assets/intro_icon6.png"),
          num: 0,
          title: "专家",
          title_en: "Experts",
          unit: "",
        },
      ],
      showNum: false,
    };
  },
  mounted() {
    this.langSet = this.$language;
    this.list[0].num = this.introduceData.area;
    this.list[1].num = this.introduceData.company_num;
    this.list[2].num = this.introduceData.audience_num;
    this.list[3].num = this.introduceData.interface_meeting;
    this.list[4].num = this.introduceData.frontier;
    this.list[5].num = this.introduceData.expert;
    // 25.9.12 滑动到指定元素，数字动画效果 dxm
    this.$nextTick(() => {
      window.addEventListener("scroll", this.scroll, true);
    });
  },
  methods: {
    scroll() {
      const el = this.$refs.scroll;
      if (el) {
        var top = el.getBoundingClientRect().top; // 元素顶端到可见区域顶端的距离
        var se = document.documentElement.clientHeight; // 浏览器可见区域高度。
        if (!this.showNum && top < se) {
          this.showNum = true;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.intro-top {
  font-size: 22px;
  color: #001a33;
  line-height: 40px;
  padding-top: 127px;
  .left {
    flex: 1;
    & > div {
      text-indent: 45px;
    }
  }
  .right {
    width: 573px;
    height: 316px;
    overflow: hidden;
    margin-left: 50px;
    background: #ccc;
    border-radius: 20px;
    #video {
      width: 100%;
      height: 100%;
      object-fit: fill; /* 或 contain/cover */
    }
  }
}
.intro-list {
  padding: 122px 0 110px;
  background: url("../../../assets/intro_bg.jpg") left no-repeat;
  background-size: 100%;
  .item {
    width: 320px;
    min-height: 140px;
    font-size: 20px;
    color: #001a33;
    line-height: 28px;
    padding: 35px 0 10px 57px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 30px;
    margin: 0 0 40px 80px;
    .icon {
      width: 32px;
      height: 32px;
      margin-top: 7px;
      margin-right: 15px;
    }
    .item-con {
      flex: 1;
    }
    .num {
      font-weight: bold;
      font-size: 38px;
      color: #001a33;
      line-height: 45px;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .intro-top .right {
    width: 450px;
    height: 255px;
  }
  .intro-list .item {
    width: 280px;
    padding-left: 40px;
    margin-left: 50px;
  }
}
@media only screen and (max-width: 767px) {
  .intro-top {
    font-size: 0.29rem;
    line-height: 0.46rem;
    flex-wrap: wrap;
    padding-top: 0.56rem;
    .right {
      margin: 0.38rem 0;
      width: 100%;
    }
  }
  .intro-list {
    padding: 0.9rem 0;
    background-size: 100% 160%;
    .item {
      width: 3.17rem;
      min-height: 1.94rem;
      font-size: 0.27rem;
      line-height: 0.38rem;
      padding: 0.54rem 0 0 0.23rem;
      margin-left: 0;
      margin-right: 0.38rem;
      border-radius: 18px;
      &:nth-child(2n) {
        margin-right: 0 !important;
      }
      &:nth-child(3n) {
        margin-right: 0.38rem;
      }
      .icon {
        width: 0.46rem;
        height: 0.46rem;
        margin-right: 0.12rem;
      }
      .num {
        font-size: 0.46rem;
        line-height: 0.56rem;
      }
    }
  }
}
</style>